import * as React from 'react';
import { FlashMessages } from './messages'
import { Component } from '../../lib/component';
import {Notification} from '../notification';
import {FlashMessage} from '../../types';

export interface FlashItemProps {
  message: FlashMessage
  onRequestClose(): void;
}

export class FlashItem extends Component<FlashItemProps> {
  render() {
    const { message, onRequestClose } = this.props;
    const Message: any = FlashMessages[message.type] || FlashMessages['Info'];

    return (
      <Notification
        onRequestClose={onRequestClose}
        model={Message(message.props)}
      />
    );
  }
}